(ns frontend.view.modals.account-select.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.components.radix-ui.avatar.view :as avatar]
   [ui.dom-globals :as dg]
   [ui.editors.data-input :as data-input]
   [ui.util :as uu]))

(defonce modal-key :account-select-modal)

;; creates single account cards inside modals
(defn modal-card-account
  [{:keys [account is-selected? on-change-single-select!]}]
  (let [{:keys [account/first-name account/last-name]} account]
    [:div
     [:div
      (merge {:class-name (uu/cm "p-3
                                 flex gap-3 items-center
                                 bg-base-light
                                 rounded cursor-pointer
                                 border border-solid"
                                 (if is-selected? "border-base-light-border hover:border-base-light-border-accent"
                                                  "border-base-light-border-paler"))}
             (when-not is-selected?
               {:on-click (fn [e]
                            (dg/stop-propagation e)
                            (on-change-single-select!))}))

      [avatar/view
       {:image-url (:account/picture-url account)
        :fallback  (entity/get-initials account)
        :size      :medium
        :font-size :medium}]

      [:p
       {:class "font-semibold"}
       (str first-name " " last-name)]]]))

(defn view
  [{:keys [shown? close-modal! props state topmost?]}]
  (let [{:keys [active-accounts header-text on-select!]} props
        selected-account-id (:selected-account-id @state)]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     header-text
     [:<>
      (when (> (count active-accounts) 10)
        [:div
         {:class "mb-3 relative"}
         [data-input/view
          {:data-type   :data.type/text-simple
           :placeholder (loc/tr :search)
           :value       (:search-txt @state)
           :class       "w-full"
           :on-change   #(swap! state assoc :search-txt %)}]
         [:span
          {:class "absolute -translate-y-1/2 top-1/2 right-2"}
          [:i.fal.fa-search]]])
      [:div
       {:class "flex flex-col flex-wrap gap-2"}
       (->> active-accounts
            (remove
             (fn [acc]
               (when-let [search (not-empty (cu/str-trim-lcase (:search-txt @state)))]
                 (not (string/includes? (cu/str-trim-lcase (entity/display-string acc)) search)))))
            (map (fn [acc]
                   (let [account-id (:db/id acc)]
                     ^{:key (str "collapse-block-account_" account-id)}
                     [modal-card-account
                      {:account      acc
                       :is-selected? (= account-id selected-account-id)
                       :on-change-single-select!
                       (fn []
                         (swap! state assoc :selected-account-id account-id))}])))
            (doall))]]
     [modal/footer-children-left-and-right
      [[button/secondary-hollow
        {:on-click (fn [_]
                     (close-modal!))}
        (loc/tr :cancel)]]
      [[button/primary-solid
        {:disabled? (nil? selected-account-id)
         :on-click  (fn [_]
                      (on-select! close-modal! selected-account-id))}
        (loc/tr :confirm)]]
      ]]))
